import type { ReactNode } from 'react';

type Props = {
  children?: ReactNode;
};

/** 仅小屏展示：提醒复杂操作适合在电脑浏览器完成 */
export function PcRecommendedCallout({ children }: Props) {
  return (
    <div
      className="relative mb-4 overflow-hidden rounded-xl border border-amber-200/60 bg-gradient-to-r from-amber-50/95 to-orange-50/40 px-4 py-3 text-[13px] leading-snug text-amber-950 shadow-sm shadow-amber-900/5 md:hidden"
      role="note"
    >
      <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-amber-400 to-orange-400" aria-hidden />
      <p className="pl-2 font-semibold text-amber-900">建议在电脑浏览器中完成</p>
      <p className="mt-1 pl-2 text-amber-950/90">
        {children ??
          '本页含多列表格、长表单或需复制的链接，宽屏下更高效；手机端适合临时查看。'}
      </p>
    </div>
  );
}
